angular
    .module('webcomm')
    .directive('privateCall', function () {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                channel: '=',
                selectedChannelId: '=',
                created: '&onCreated',
                removed: '&onRemoved'
            },
            templateUrl: 'app/main/channel/privateCallChannel.html',
            controller: 'PrivateCallChannelController',
            controllerAs: 'pcc'
        };
    })
    .controller(
        'PrivateCallChannelController', [
            '$scope',
            '$log',
            '$timeout',
            'channelModel',
            'privateCallPttService',
            'privateCallService',
            function ($scope, $log, $timeout, channelModel, privateCallPttService, privateCallService) {
                var vm = this;
                this.$onInit = function () {
                    var channelPttService = privateCallPttService.create(vm.channel.id);
                    var activityMessageTimer;
                    var _pttPending = false;

                    function displayActivityMessaage(msg) {
                        vm.status.activityMessage = msg;
                        vm.status.isActivityMessageVisible = true;

                        activityMessageTimer = $timeout(function () {
                            vm.status.activityMessage = "";
                            vm.status.isActivityMessageVisible = false;
                        }, 5000);
                    }

                    function callRequest(pttPending) {
                        privateCallService.callRequest(vm.channel.calleeNumber, vm.channel.participantId, vm.channel.calleeName, vm.channel.bargeCall)
                            .then(() => {
                                vm.status.activityMessage = ""; // Should probably be a call timer
                                if (pttPending && vm.channel.bargeCall) {
                                    _pttPending = true;
                                }
                            })
                            .catch((err) => {
                                $log.error(err);
                                vm.status.activityMessage = err;
                            });
                    }

                    vm.created();

                    vm.status = {
                        isSelected: function () { return vm.selectedChannelId === vm.channel.id; },
                        isPTTButtonEnabled() {
                            return vm.channel.bargeCall || channelPttService.canTransmitAudio();
                        },
                        getPttIconName() {
                            return channelPttService.getPttIconName(this.isSelected());
                        },
                        isPttOn() {
                            return channelPttService.isPttOn();
                        },
                        activeCallExists: privateCallService.activeCallExists,
                        callOfferFromUserExists: privateCallService.callOfferFromUserExists,
                        isActivityMessageVisible: false,
                        callEnded: false,
                        callAnswered: vm.channel.callActive,
                        isDialing: false
                    }

                    vm.hidePhoneIcon = () => {
                        return this.status.isDialing ||
                            this.status.callAnswered ||
                            this.status.activeCallExists() ||
                            this.status.callOfferFromUserExists(this.channel.participantId);
                    };

                    vm.closeChannel = function () {
                        vm.channel.active = false;

                        $scope.$emit('privateCallChannelClosed', vm.channel);
                    };

                    vm.pttStart = function ($event) {
                        var pttState = vm.status.getPttIconName();
                        $log.debug('private call pttStart', pttState);
                        // this is to stop the system from interpreting the PTT click as a channel select
                        if ($event) {
                            $event.stopImmediatePropagation();
                        }

                        if (!channelPttService.isPttOn() && pttState !== 'disabled' && pttState !== 'requesting') {

                            if (vm.channel.bargeCall && !vm.status.callAnswered && !vm.status.isDialing) {
                                callRequest(true);
                            } else {
                                channelPttService.pttStart();
                            }
                        }
                    };

                    vm.pttStop = function ($event) {
                        $log.debug('private call pttStop');
                        // this is to stop the system from interpreting the PTT click as a channel select
                        if ($event) {
                            $event.stopImmediatePropagation();
                        }

                        if (channelPttService.isPttOn()) {
                            channelPttService.pttStop();
                        }
                    };

                    vm.phoneButtonClick = function ($event) {
                        if ($event) {
                            $event.stopImmediatePropagation();
                        }

                        if (!vm.status.callAnswered && !vm.status.isDialing) {
                            callRequest();
                        }
                        else {
                            privateCallService.callHangup(vm.channel.callId)
                                .then(() => {
                                    if (vm.status.callAnswered) {
                                        vm.status.activityMessage = 'Call ended';
                                    }
                                    else {
                                        vm.status.activityMessage = 'Call cancelled';
                                    }

                                    vm.status.isDialing = false;
                                    vm.status.callAnswered = false;
                                    vm.status.isActivityMessageVisible = true;
                                });
                        }
                    };

                    vm.highlightSpeakingChannel = function (isHighlighted = true) {
                        vm.status.talkingHighlightClass = isHighlighted ? "talking5" : "";
                    };

                    var unbindPrivateCallPTTOff = $scope.$on('privateCallService.callPttOff', (e, call) => {
                        if (vm.channel.callId === call.callId) {
                            channelPttService.callTooLong();
                        }
                    });

                    var unbindPrivateCallProgress = $scope.$on('privateCallService.callProgressReceived', (e, data) => {
                        if (vm.channel.callId === data.callId) {
                            if (data.callState === 2) {
                                vm.status.isActivityMessageVisible = false;
                                vm.status.callAnswered = false;
                                vm.status.isDialing = true;
                            } else if (data.callState === 3) {
                                if (_pttPending) {
                                    _pttPending = false;
                                    channelPttService.pttStart();
                                }
                                vm.status.isDialing = false;
                                vm.status.callAnswered = true;
                                vm.status.activityMessage = '';
                            }
                        }
                    });

                    var unbindPrivateCallHangup = $scope.$on('privateCallService.callHangupReceived', (e, data) => {
                        if (data) {
                            if (vm.channel.callId === data.callId) {
                                vm.status.isDialing = false;
                                if (vm.status.callAnswered) {
                                    vm.status.activityMessage = 'Call ended';
                                }
                                else {
                                    vm.status.activityMessage = 'No answer';
                                }

                                vm.status.callAnswered = false;
                                vm.status.isActivityMessageVisible = true;
                            }
                        }
                    });

                    var unbindReconnecting = $scope.$on('isReconnecting', (e, reconnecting) => {
                        if (reconnecting) {
                            vm.status.isDialing = false;
                            vm.status.callAnswered = false;
                        }
                    });

                    $scope.$on(
                        "$destroy",
                        function (event) {
                            vm.removed();
                            unbindReconnecting();
                            unbindPrivateCallProgress();
                            unbindPrivateCallHangup();
                            unbindPrivateCallPTTOff();
                            if (activityMessageTimer) {
                                $timeout.cancel(activityMessageTimer);
                            }
                        }
                    );

                    vm.select = function (channelId) {
                        if (!vm.status.isSelected()) {
                            vm.isMobileFeedVisible = true;
                            channelModel.selectChannel(channelId);
                        } else { // Barf, i hate this, but best I can do for now --scott s
                            $scope.$parent.mobile.isMainMenuSelected = false;
                        }
                    };
                };
            }
    ]);
